import React, {useMemo} from 'react';
import cn from 'classnames';

import {parseColClasses} from '../../helpers';

import {IGridColumnProps} from './IGridColumn';

const GridColumn = ({xxl, xl, lg, md, sm, xs, classNames, style, children, edgeToEdge, ref}: IGridColumnProps) => {
	const parsedColumnClasses = useMemo(() => parseColClasses({xxl, xl, lg, md, sm, xs}), [xxl, xl, lg, md, sm, xs]);

	const attrs: {className: string; style?: React.CSSProperties} = {
		className: cn(classNames, ...parsedColumnClasses),
	};

	// Prepare the styles object
	let stylesObj = {};

	// Handling styles
	if (style) {
		stylesObj = {...stylesObj, ...style};
	}

	// Check if we have styles to apply
	if (Object.keys(stylesObj).length) {
		attrs.style = stylesObj;
	}

	if (edgeToEdge) {
		attrs.className += ' edge-to-edge';

		return (
			<div {...attrs} ref={ref}>
				<div className="edge-to-edge__content">{children}</div>
			</div>
		);
	}

	return <div ref={ref} {...attrs}>{children}</div>;
};

export default GridColumn;
